import {
    AboutText,
    AudioPlayer,
    KinescopeVideoPlayer,
} from "modules/PsyProfile/components/AboutMe/components"
import style from "modules/PsyProfile/components/AboutMe/style.module.scss"
import { Analytics } from "utils/analytics"
import { Psychologist } from "utils/interfaces"
import { Box } from "ui-kit/components-branded/Box"

export function AboutMe({ psy }: { psy: Psychologist }) {
    const onPlayVideo = () => {
        Analytics.profile_video_opened({ psy })
    }

    return (
        <section className={style.container}>
            <Box className={style.container}>
                <h2 className={style.title} data-testid="psy-profile-about-title">
                    Психолог о себе
                </h2>
                {psy.video && (
                    <div className={style.video} data-testid="psy-profile-video">
                        <KinescopeVideoPlayer video={psy.video} onPlay={onPlayVideo} />
                    </div>
                )}
                {psy.audio && !psy.video && (
                    <div className={style.audio} data-testid="psy-profile-audio">
                        <div className="has-constant-gaps">
                            <AudioPlayer src={psy.audio} psy={psy} />
                        </div>
                    </div>
                )}
                <AboutText psy={psy} />
            </Box>
        </section>
    )
}
